/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserDetails {
    getFixupPrototypeFunction() { return UserDetails.fixupPrototype; }

    static newInstance(model: Partial<UserDetails>): UserDetails {
        let obj = Object.assign(new UserDetails(), model);
        UserDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserDetails>): UserDetails {
        if (!model) return null;
        return UserDetails.newInstance(<UserDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserDetails) {
        if (!obj) return;

        models.UserDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserDetails): boolean {
        Object.setPrototypeOf(obj, UserDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.role_assignment) {
            for (let val of this.role_assignment) {
                models.RoleAssignment.fixupPrototype(val);
            }
        }
    }

    /**
     * ID of the User. This is an auto generated and unique in the CoreStack system
     */
    user_id: string;

    /**
     * Username is unique in the CoreStack system. User can use this to login to CoreStack portal in addition to email
     */
    username: string;

    /**
     * Current Status of the user - active or inactive. Inactive user cannot login or use AccessKeys
     */
    status: string;

    /**
     * Email of the User. This is unique in the CoreStack system
     */
    email: string;

    /**
     * List of roles assignments or the user. The same user can be assigned different roles in different tenants
     */
    role_assignment: Array<models.RoleAssignment>;

    /**
     * Id of the Timezone such as Asia/Kolkata, Asia/Dubai and so on
     */
    timezone_id: string;

    /**
     * source user id
     */
    source_user_id: string;

}
